'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MouseoverDictionary = function (_React$Component) {
  _inherits(MouseoverDictionary, _React$Component);

  function MouseoverDictionary(props) {
    _classCallCheck(this, MouseoverDictionary);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MouseoverDictionary).call(this, props));

    _this.rebind = _this.rebind.bind(_this);
    return _this;
  }

  _createClass(MouseoverDictionary, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unbind) {
        this.unbind();
        this.unbind = null;
      }
    }
  }, {
    key: 'rebind',
    value: function rebind(dom) {
      if (this.unbind) {
        this.unbind();
        this.unbind = null;
      }

      if (dom) {
        this.unbind = (0, _index2["default"])(dom, {
          scan: this.props.scan
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var html = this.props.html;
      return html ? _react2["default"].createElement('span', {
        ref: this.rebind,
        dangerouslySetInnerHTML: {
          __html: html
        }
      }) : _react2["default"].createElement('span', {
        ref: this.rebind
      }, this.props.children);
    }
  }]);

  return MouseoverDictionary;
}(_react2["default"].Component);

exports["default"] = MouseoverDictionary;
MouseoverDictionary.propTypes = {
  scan: _react.PropTypes.bool,
  html: _react.PropTypes.string,
  children: _react.PropTypes.any
};